import {
  useActionItem,
  ActionItemOperation as Operation,
} from '@workboard/action-item';

import { useModal } from '../../utils/useModal';
import { RemindMeModal } from '../../RemindMeModal';

export function useRemindMeModal(aiId: string | null) {
  const { isPermitted } = useActionItem(aiId);
  const canRemind = isPermitted(Operation.remind);

  const { show: showRemindMeModal } = useModal(RemindMeModal, {
    aiId,
  });

  return [canRemind, showRemindMeModal] as const;
}
